import { assert_type_enum } from '@shared/asserts/utils_asserts';
import { DTO__base } from '@shared/common/DTO__base';
import { ENUM__language_type } from '@shared/enums/ENUM__language_type';
import { ENUM__dto_class_name } from '@shared/serialization/ENUM__dto_class_name';
import { DTO__word } from './DTO__word';

export class DTO__words_vocabulary extends DTO__base {
  static _class_name_static: string = ENUM__dto_class_name.WORDS_VOCABULARY;

  language!: string;

  //key - word english
  words_map: Map<string, DTO__word>;

  /*
   * METHODS
   */

  constructor() {
    super();
    this.words_map = new Map<string, DTO__word>();
  }

  assert_standard_fields(): void {
    assert_type_enum(this.language, ENUM__language_type);
  }
}
